import { IDataSource } from './data-source';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { UiSearchDefinitionService, WorkSearchFoundationService } from 'e5core-angular-services';
import { DataSourceColumn, DataSourceColumnStatus } from './data-source-column';
import { DataSourceResults } from './data-source-results';
import { FoundationWorkFindWorkItemResultModel } from 'e5core-angular-services';
import { FoundationWorkFindWorkItemColumnDefModel } from 'e5core-angular-services';
import { SearchDataSourceOptions } from './search-data-source-options';
import { DataSourceOptions } from './data-source-options';
import { DataSourceQuery } from './data-source-query';

const TESTDATA = {
    '$id': '2111',
    'findClassId': 4,
    'page': 0,
    'pageSize': 10,
    'resultCount': 10,
    'total': 24,
    'columns': [
       {
          '$id': '2112',
          'code': 'Id',
          'label': 'Work Id',
          'type': 'System.Guid'
       },
       {
          '$id': '2113',
          'code': 'SLAExpiryDate',
          'label': 'Due Date',
          'type': 'System.DateTime'
       },
       {
          '$id': '2114',
          'code': 'Allocation',
          'label': 'Allocation',
          'type': 'System.String'
       },
       {
          '$id': '2115',
          'code': '_NextDueTask',
          'label': 'Next Due Task',
          'type': 'System.String'
       },
       {
          '$id': '2116',
          'code': 'Status_Id',
          'label': 'Status',
          'type': 'System.String'
       },
       {
          '$id': '2117',
          'code': 'AssignedUser',
          'label': 'Assigned User',
          'type': 'System.String'
       },
       {
          '$id': '2118',
          'code': 'Category1_Id',
          'label': 'Business Area',
          'type': 'System.String'
       },
       {
          '$id': '2119',
          'code': 'Category3_Id',
          'label': 'Category',
          'type': 'System.String'
       },
       {
          '$id': '2120',
          'code': 'HealthFundNumber',
          'label': 'Client Number',
          'type': 'System.String'
       },
       {
          '$id': '2121',
          'code': 'FirstName',
          'label': 'First Name',
          'type': 'System.String'
       },
       {
          '$id': '2122',
          'code': 'Surname',
          'label': 'Surname',
          'type': 'System.String'
       },
       {
          '$id': '2123',
          'code': 'Category2_Id',
          'label': 'Product Type',
          'type': 'System.String'
       },
       {
          '$id': '2124',
          'code': 'ProviderName',
          'label': 'Provider Name',
          'type': 'System.String'
       },
       {
          '$id': '2125',
          'code': 'ProviderNumber',
          'label': 'Provider Number',
          'type': 'System.String'
       },
       {
          '$id': '2126',
          'code': 'Reference',
          'label': 'Reference',
          'type': 'System.Int32'
       },
       {
          '$id': '2127',
          'code': 'RelatedItem',
          'label': 'Related Items',
          'type': 'System.String'
       },
       {
          '$id': '2128',
          'code': '_SLAExpiryStatus',
          'label': '_SLAExpiryStatus',
          'type': 'System.String'
       }
    ],
    'results': [
       [
          'ca3a1219-03eb-11e9-9682-005056ba65e4',
          '2018-12-24T11:11:27+11:00',
          '2|1005|1011|0',
          null,
          'Complete',
          null,
          'Member Health',
          'Benefit Eligibility',
          '29405564',
          null,
          null,
          'Ancillary Benefits Management',
          '',
          '25',
          1778,
          null,
          'within'
       ],
       [
          '603b82ff-03e6-11e9-9682-005056ba65e4',
          '2018-12-24T10:32:41+11:00',
          '2|1002|1037|0',
          null,
          'Complete',
          'Leo Santos',
          'Member Health',
          'Benefit Eligibility',
          '29405564',
          null,
          null,
          'Clinical Review',
          '',
          '24',
          1776,
          null,
          'within'
       ],
       [
          '2b4701f5-03e6-11e9-9682-005056ba65e4',
          '2018-12-24T10:31:12+11:00',
          '2|1005|1010|0',
          null,
          'Active',
          null,
          'Member Health',
          'Benefit Review',
          '29405564',
          null,
          null,
          'Ancillary Benefits Management',
          '',
          '22',
          1775,
          null,
          'within'
       ],
       [
          'f2e4ce57-033d-11e9-9682-005056ba65e4',
          '2018-12-21T14:27:02+11:00',
          '2|1005|1014|0',
          null,
          'Complete',
          'Devashi Wesumperuma',
          'Member Health',
          'Investigation',
          '29405564',
          null,
          null,
          'Ancillary Benefits Management',
          '',
          '19',
          1769,
          null,
          'within'
       ],
       [
          '6d575c6c-0327-11e9-9682-005056ba65e4',
          '2018-12-21T11:45:49+11:00',
          '2|1006|1012|0',
          null,
          'Complete',
          'Vinh Tang',
          'Member Health',
          'Unclassified',
          '29405564',
          null,
          null,
          'Unclassified',
          '',
          '18',
          1768,
          null,
          'within'
       ],
       [
          'd417c057-0326-11e9-9682-005056ba65e4',
          '2018-12-21T11:41:32+11:00',
          '2|1006|1012|0',
          null,
          'Complete',
          null,
          'Member Health',
          'Unclassified',
          '29405564',
          null,
          null,
          'Unclassified',
          '',
          '17',
          1767,
          null,
          'within'
       ],
       [
          'f72a5b05-0325-11e9-9682-005056ba65e4',
          '2018-12-21T11:35:22+11:00',
          '2|1004|1017|0',
          null,
          'Complete',
          null,
          'Member Health',
          'Exgratia',
          '29405564',
          null,
          null,
          'Compensable',
          '',
          '16',
          1766,
          null,
          'within'
       ],
       [
          'e88fefe7-0325-11e9-9682-005056ba65e4',
          '2018-12-21T11:34:57+11:00',
          '2|1005|1010|0',
          null,
          'Complete',
          null,
          'Member Health',
          'Benefit Review',
          '29405564',
         null,
          null,
          'Ancillary Benefits Management',
          '',
          '15',
          1765,
          null,
          'within'
       ],
       [
          '644e3d8c-0325-11e9-9682-005056ba65e4',
          '2018-12-21T11:31:15+11:00',
          '2|1005|1010|0',
          null,
          'Complete',
          null,
          'Member Health',
          'Benefit Review',
          '29405564',
          null,
          null,
          'Ancillary Benefits Management',
          '',
          '14',
          1764,
          null,
          'within'
       ],
       [
          '3588e678-0325-11e9-9682-005056ba65e4',
          '2018-12-21T11:29:57+11:00',
          '2|1003|1031|0',
          null,
          'Complete',
          null,
          'Member Health',
          'Investigation',
          '29405564',
          null,
          null,
          'Investigations',
          '',
          '13',
          1763,
          null,
          'within'
       ]
    ]
 } ;

@Injectable({
    providedIn: null // 'root'
})
export class SearchDataSourceService implements IDataSource {

    readonly SlaExpiryColumnCode = '_SLAExpiryStatus';
    readonly NextTaskColumnCode = '_NextDueTask';

    searchDefinitionId = 0;
    searchOptions: SearchDataSourceOptions = {} ;

    constructor(private searchDefinitionService: UiSearchDefinitionService, private searchService: WorkSearchFoundationService) {
    }

    public defaultOptions(): DataSourceOptions {
        return (this.searchOptions) ;
    }

    public setDefaultOptions(options: DataSourceOptions) {
        this.searchOptions = {...options} ; // clone
    }

    public setSearchDefinitionId(id: number): SearchDataSourceService {
        this.searchDefinitionId = id;
        return (this);
    }

    columns(): Observable<DataSourceColumn[]> {
        return this.searchDefinitionService.get(this.searchDefinitionId).pipe<DataSourceColumn[]>(
            map(r => {
                const columns = r.searchFields.map<DataSourceColumn>(sf => <DataSourceColumn>{
                    code: sf.fieldDefinitionId,
                    label: sf.fieldLabel,
                    type: sf.fieldDataType,
                    status: sf.fieldStatus
                }) ;
                return this.addOptionalColumns(columns) ;
            })
        ) ;
    }

    private addOptionalColumns(columns: DataSourceColumn[]): DataSourceColumn[] {
        if (this.searchOptions) {
            if (this.searchOptions.includeSla) {
                // Add to start
                columns.unshift(<DataSourceColumn>{
                    label: 'SLA',
                    code: this.SlaExpiryColumnCode,
                    type: 'SLA',
                    status: DataSourceColumnStatus.Selected
                }) ;
            }
            if (this.searchOptions.includeNextDueTask) {
                // Add to end
                columns.push(<DataSourceColumn>{
                    code: this.NextTaskColumnCode,
                    label: 'Next Due Task',
                    type: 'Input',
                    status: DataSourceColumnStatus.Selected
                }) ;
            }
        }
        return (columns) ;
    }

    public read(page: number, pageSize: number, optionsIn: DataSourceOptions): Observable<DataSourceResults> {
        const options: SearchDataSourceOptions = {
            ...this.searchOptions,
            ...optionsIn,
            page: page,
            pageSize: pageSize
        }
        
        const filterBy = this.mapQueryToFilterBy(options.query) ;
        return this.searchService.getFindWorkItem(this.searchDefinitionId, filterBy, options)
            .pipe<DataSourceResults>(
                map(results => {
                    return {
                        total: results.total,
                        data: this.mapResults(results)
                    };
                })
        );
    }

    /**
   * The data that comes back from the API is a columns defintion and an array
   * of array of data. We need to map this into an array of objects with the column property
   * id as the object key so that it's easier to handle by the table.
   * @param model
   */
    private mapResults(model: FoundationWorkFindWorkItemResultModel): any[] {

        const data: any[][] = model.results;
        let results: any[];

        if (model && model.total > 0 && model.results && model.columns) {
            const colDefs: FoundationWorkFindWorkItemColumnDefModel[] = model.columns;

            results = model.results.map<any>(r => {
                const dataRow: any[] = r;
                const objectRow: any = {};
                for (let c = 0; c < colDefs.length; c++) {
                    const columnDef = colDefs[c];
                    objectRow[columnDef.code] = dataRow[c];
                }
                return (objectRow);
            });
        }
        return results ;
    }

    //  In order to use the foundation service we need to map the DataSourceQuery into 
    //  the underlying foundation query
    // 	{
    // 		'filters': [
    // 	  		{
    // 				'field': 'string',
    // 				'operator': 'string',
    // 				'value': 'string'
    // 	  		}
    // 		],
    // 		'logic': 'string'
    // 	}
    private mapQueryToFilterBy(query: DataSourceQuery): any {
        let filterBy = {} ;
        if (query && query.Expressions && query.Expressions.length > 0) {
            const filters = query.Expressions
                .filter( e => e.Value )
                .map( e => {
                    return {
                        field : e.Field,
                        value : e.Value
                    };
                }) ;
            filterBy = {
                filters : filters
            };
        }
        return (filterBy) ;
    }
}